import { styled } from "@pigment-css/react";
import { useTranslations } from "@acto/web-common/locales";
import { RotateCounterClockwise } from "@acto/web-common/components";
import { SecondaryButton } from "@acto/taskpane/field-sales-2/components/primitives/SecondaryButton";

const Frame = styled("div")(({ theme }) => ({
  width: "100%",
  minHeight: "22rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.fieldSalesTwo.spacing[24],
  padding: theme.fieldSalesTwo.spacing[24],
  borderRadius: theme.fieldSalesTwo.radius["44"],
  background: theme.fieldSalesTwo.colors.surface.glass,
  border: `1px solid ${theme.fieldSalesTwo.colors.surface.glassBorder}`,
  boxSizing: "border-box",
}));

const Notice = styled("p")(({ theme }) => ({
  margin: 0,
  textAlign: "center",
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size.base,
  fontWeight: theme.fieldSalesTwo.font.weight["520"],
  lineHeight: theme.fieldSalesTwo.font.lineHeight["148"],
  color: theme.fieldSalesTwo.colors.neutral[900],
}));

const UndoButton = styled(SecondaryButton)(() => ({
  "& svg": { width: "20px", height: "auto", flexShrink: 0 },
}));

interface StoryCardRemovedNoticeProps {
  onUndo: () => void;
}

/** Removal confirmation with undo. */
export function StoryCardRemovedNotice({ onUndo }: StoryCardRemovedNoticeProps) {
  const t = useTranslations("fieldSalesTwo.genuiMeetingPrep.storyCard.removal");

  return (
    <Frame>
      <Notice>{t("removedNotice")}</Notice>
      <UndoButton type="button" onClick={onUndo}>
        <RotateCounterClockwise aria-hidden="true" />
        {t("undo")}
      </UndoButton>
    </Frame>
  );
}
